export * from './app-remove-dialog.component';


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/components/app-remove-dialog/index.ts